module.exports = __webpack_public_path__ + "static/img/RoundCloseBtn.f02907eb.svg";